import BasicAccount from "./BasicAccount";

export default BasicAccount;
